import { Table, ConfigProvider, theme } from "antd";
import { createStyles } from "antd-style";
import map from "lodash/map";
import get from "lodash/get";
import omit from "lodash/omit";
import assign from "lodash/assign";

import andonColumns from "../../constants/tableColumns/andonTableColumn";

const useStyle = createStyles(({ css, token }) => {
  const { antCls } = token;
  return {
    customTable: css`
      ${antCls}-table {
        ${antCls}-table-container {
          ${antCls}-table-body,
          ${antCls}-table-content {
            scrollbar-width: thin;
            scrollbar-color: #eaeaea transparent;
            scrollbar-gutter: stable;
          }
        }
      }
    `,
  };
});

const { darkAlgorithm } = theme;

const getTableData = (templateStats) => {
  if (!templateStats) return [];
  const data = [];
  map(templateStats, (stats) => {
    const obj = omit(stats, "parts");
    map(get(stats, "parts"), (part, index) => {
      const p = { ...obj, part };
      if (index === 0) {
        assign(p, { span: get(stats, "parts", []).length });
      }
      data.push(p);
    });
  });
  return data;
};

const TableSection = ({ templateStats }) => {
  const tableBackground = "#374151";
  const tableBorderColor = "#111827";
  const { styles } = useStyle();

  return (
    <div className="py-9">
      <ConfigProvider
        theme={{
          algorithm: darkAlgorithm,
          token: {
            colorPrimary: "#4f46e5",
            colorText: "#e6eef8",
            colorBgContainer: tableBackground,
            colorBorder: tableBorderColor,
            colorBorderSecondary: tableBorderColor,
            borderRadius: 8,
          },
        }}
      >
        <Table
          size="small"
          pagination={false}
          dataSource={getTableData(templateStats)}
          columns={andonColumns()}
          bordered
          scroll={{ y: "75vh" }}
          className={styles.customTable}
          rowKey={(record) => get(record, "id") || crypto.randomUUID()}
        />
      </ConfigProvider>
    </div>
  );
};

export default TableSection;
